import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const shopifyPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('shopify:refreshed', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetRefreshed(payload),
  );

  partnerEvents.on('shopify:view:customer:clicked', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked(payload),
  );

  partnerEvents.on('shopify:view:order:clicked', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked(
      payload,
    ),
  );

  partnerEvents.on('shopify:view:all:orders:clicked', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked(
      payload,
    ),
  );

  partnerEvents.on('shopify:order:refund:requested', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderRefundRequested(payload),
  );

  partnerEvents.on('shopify:order:refund:canceled', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderRefundCanceled(payload),
  );

  partnerEvents.on('shopify:order:refund:confirmed', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderRefundConfirmed(payload),
  );

  partnerEvents.on('shopify:order:collapse:opened', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderCollapseOpened(payload),
  );

  partnerEvents.on('shopify:order:collapse:closed', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderCollapseClosed(payload),
  );

  partnerEvents.on(
    'shopify:order:edit:shipping:address:modal:opened',
    (payload) =>
      ampli.partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened(
        payload,
      ),
  );

  partnerEvents.on(
    'shopify:order:edit:shipping:address:modal:submitted',
    (payload) =>
      ampli.partnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted(
        payload,
      ),
  );

  partnerEvents.on(
    'shopify:order:edit:shipping:address:modal:canceled',
    (payload) =>
      ampli.partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled(
        payload,
      ),
  );

  partnerEvents.on('shopify:order:tags:updated', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderTagsUpdated(payload),
  );

  partnerEvents.on('shopify:order:cancelled', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetOrderCancelled(payload),
  );

  partnerEvents.on('shopify:discount:code:created', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetDiscountCodeCreated(payload),
  );

  partnerEvents.on('shopify:profile:created', (payload) =>
    ampli.partnerIntegrationsShopifyWidgetProfileCreated(payload),
  );
};
